import { IonBackButton, IonButton, IonButtons, IonCol, IonHeader, IonIcon, IonRow, IonTitle, IonToolbar } from "@ionic/react"
import { arrowForwardOutline, menuOutline } from "ionicons/icons"
import './Toolbar2.css'

interface Props {
    title?: string,
    titleColor?: string,
    height?: number,
    startButton?: any,
    endButtons?: any,
    hasMenuButton?: boolean,
    hasBackButton?: boolean,
    hasShadow?: boolean,
    transparent?: boolean,
    background?: string
}

const Toolbar2: React.FC<Props> = (props) => {
    let headerClassName = ["ion-no-border toolbar2"];

    if (props.hasShadow !== undefined && props.hasShadow) {
        headerClassName.push("has-shadow");
    }

    if (props.transparent !== undefined) {
        headerClassName.push("transparent");
    }

    return <IonHeader className={headerClassName.join(" ").toString()} style={{ height: props.height !== undefined ? props.height + 'px' : null, background: props.background !== undefined ? props.background : null }}>
        <IonToolbar>
            <IonButtons slot="start">
                {props.startButton}
                {props.hasMenuButton ?
                    <IonButton shape="round" color="white">
                        <IonIcon icon={menuOutline} />
                    </IonButton> : null}
                {props.hasBackButton ?
                    <IonBackButton style={props.hasShadow ? { filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.2))' } : {}} defaultHref="/" color="white" text="" mode={window.layoutMode} /> : null}
            </IonButtons>

            <IonRow className="title-container">
                <IonCol size="12">
                    <IonTitle className="title" style={{ color: props.titleColor }}>{props.title}</IonTitle>
                </IonCol>
            </IonRow>

            <IonButtons slot="end">
                {props.endButtons}
            </IonButtons>
        </IonToolbar>

        {props.children}
    </IonHeader>
}

export default Toolbar2